import { Link } from "react-router-dom";
import { ArrowUpRight, Gift } from "lucide-react";

export const BlogReferralBadge = () => (
  <div className="pt-8 flex justify-center" data-testid="blog-referral-section">
    <Link to="/refer-a-friend" data-testid="blog-refer-friend-badge"
      className="inline-flex items-center justify-center gap-3 rounded-full border border-[#D4AF37] bg-[#0B0F0D] px-6 py-3 text-sm font-bold text-[#D4AF37] hover:bg-emerald-950 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-700 focus-visible:ring-offset-4 transition-[background-color,transform]">
      <Gift size={20} aria-hidden="true" /> Refer a friend <ArrowUpRight size={17} aria-hidden="true" />
    </Link>
  </div>
);